import XlsxPopulate from 'xlsx-populate';
import { omitBy, isUndefined } from 'lodash';

const NUMBER_OF_HEADERS_IN_EXCEL = 1;

const BUSINESS_CONFIGURATION_REQUIRED_COLUMNS_NAME = [
  'Business ID',
  'Business Name',
  'Pricing Plan',
  'Payment Type',
  'Cash-out Frequency',
  'Payment Gateway',
  'Extra COD Fees',
  '0 COD Discount',
  'Insurance Fees',
  'Next Day Transfer Fees',
  'Credit Limit'
];

const EXCEL_COLUMNS = {
  BUSINESS_ID: 0,
  BUSINESS_NAME: 1,
  AMOUNT: 2,
  DESCRIPTION: 3
};

const constructWalletAdjustment = (adjustment) => {
  return (
    adjustment?.length &&
    adjustment[EXCEL_COLUMNS.BUSINESS_ID] &&
    adjustment[EXCEL_COLUMNS.AMOUNT] &&
    adjustment[EXCEL_COLUMNS.DESCRIPTION] && {
      businessId: adjustment[EXCEL_COLUMNS.BUSINESS_ID]?.toString().trim(),
      amount: adjustment[EXCEL_COLUMNS.AMOUNT],
      name: adjustment[EXCEL_COLUMNS.BUSINESS_NAME]?.toString().trim(),
      description: adjustment[EXCEL_COLUMNS.DESCRIPTION]?.toString().trim()
    }
  );
};

const constructCreditsAdjustment = (adjustment) => {
  return (
    adjustment?.length &&
    adjustment[EXCEL_COLUMNS.BUSINESS_ID] &&
    adjustment[EXCEL_COLUMNS.AMOUNT] &&
    adjustment[EXCEL_COLUMNS.DESCRIPTION] && {
      businessId: adjustment[EXCEL_COLUMNS.BUSINESS_ID]?.toString().trim(),
      amount: adjustment[EXCEL_COLUMNS.AMOUNT],
      subCategory: adjustment[EXCEL_COLUMNS.DESCRIPTION]?.toString().trim()
    }
  );
};

const constructBusinessEligableLIst = (adjustment) => {
  return (
    adjustment?.length &&
    adjustment[EXCEL_COLUMNS.BUSINESS_ID] && {
      businessId: adjustment[EXCEL_COLUMNS.BUSINESS_ID]?.toString().trim(),
      name: adjustment[EXCEL_COLUMNS.BUSINESS_NAME]?.toString().trim()
    }
  );
};

const constructBusinessConfig = (adjustment) => {
  return adjustment[EXCEL_COLUMNS.BUSINESS_ID]?.toString().trim();
};

export const EXCEL_CONSTRUCT_FUNCTIONS = {
  BALANCE_ADJUSTMENT: constructWalletAdjustment,
  CREDITS_ADJUSTMENT: constructCreditsAdjustment,
  ELIGABLE_BUSINESSES: constructBusinessEligableLIst,
  BUSINESS_CONFIG: constructBusinessConfig
};

export const convertExcelToJSON = ({ file, sheetName, constructFunction }) => {
  return new Promise((resolve, reject) => {
    XlsxPopulate.fromDataAsync(file).then((workbook) => {
      try {
        const sheet = workbook.sheet(sheetName || 'Balance Adjustments');
        const sheetAdjustment = sheet
          .usedRange()
          .value()
          .slice(NUMBER_OF_HEADERS_IN_EXCEL);

        if (sheetName === 'BusinessesPaymentInfo') {
          const sheetAdjustment2 = sheet.usedRange().value();
          if (
            JSON.stringify(sheetAdjustment2[0]) !==
            JSON.stringify(BUSINESS_CONFIGURATION_REQUIRED_COLUMNS_NAME)
          ) {
            reject({
              message: 'Unsupported Template!'
            });
          }
        }

        const adjustments = sheetAdjustment
          .filter((row) => Object.keys(omitBy(row, (item) => !item)).length)
          .map((row) =>
            row.map((cell) =>
              cell instanceof XlsxPopulate.RichText
                ? cell.text().replace(/undefined/g, '')
                : cell
            )
          )
          .map(constructFunction);
        resolve(Object.values(omitBy(adjustments, isUndefined)));
      } catch (error) {
        if (error.message.includes('usedRange')) {
          error.message = 'Wrong template';
        }
        reject(error);
      }
    });
  });
};

export const handleOnTicketUrlClick = (url, isBostaPage = false) => {
  let formattedUrl = url;
  if (!isBostaPage) {
    formattedUrl = url.toLowerCase();
    const includesHTTP = formattedUrl.includes('http');
    if (!includesHTTP) {
      formattedUrl = 'http://' + formattedUrl;
    }
  }

  window.open(formattedUrl, '_blank');
};

const BULK_UPDATE_BUSINESS_PRICING_TIER = [
  'ID',
  'name',
  'Current Tier',
  'Final Tier'
];

const constructBulkUpdateBusinessPricingTier = (row) => {
  return {
    id: row[0]?.toString().trim(),
    name: row[1]?.toString().trim(),
    currentTier: row[2]?.toString().trim(),
    finalTier: row[3]?.toString().trim()
  };
};

export const convertExcelBulkUpdateBusinessessPricingTierToJSON = (file) => {
  return new Promise((resolve, reject) => {
    XlsxPopulate.fromDataAsync(file).then((workbook) => {
      try {
        const sheet = workbook.sheet('pricingTiers');

        const sheetAdjustment = sheet
          .usedRange()
          .value()
          .slice(NUMBER_OF_HEADERS_IN_EXCEL);
        const sheetWithoutHeaders = sheet.usedRange().value();

        if (
          JSON.stringify(sheetWithoutHeaders[0]) !==
          JSON.stringify(BULK_UPDATE_BUSINESS_PRICING_TIER)
        ) {
          reject({
            message: 'Unsupported Template!'
          });
        }

        const adjustments = sheetAdjustment
          .filter((row) => Object.keys(omitBy(row, (item) => !item)).length)
          .map((row) =>
            row.map((cell) =>
              cell instanceof XlsxPopulate.RichText
                ? cell.text().replace(/undefined/g, '')
                : cell
            )
          )
          .map(constructBulkUpdateBusinessPricingTier);
        resolve(adjustments);
      } catch (error) {
        if (error.message.includes('usedRange')) {
          error.message = 'Wrong template';
        }
        reject(error);
      }
    });
  });
};
